module.exports = __webpack_public_path__ + "img/blue_165.dbb3a9db.png";